import { ContentStateInterface } from '../../../../../../@types/types'
import { RealEstateCourtageInformation } from '../../../../../../@types/real-estate-api-types'
import { replaceControlCharacters } from '../../../../../../services/conversion/conversionServices'

export type CourtageInformationToApiMapper = (insertionData: ContentStateInterface) => RealEstateCourtageInformation

export const courtageInformationToApi = (insertionData: ContentStateInterface): RealEstateCourtageInformation => ({
  courtage: replaceControlCharacters(insertionData.courtage),
  courtageNote: replaceControlCharacters(insertionData.courtageNote),
  hasCourtage: insertionData.hasCourtage,
})

export const noCourtageInformationToApi = (
  _insertionData: ContentStateInterface
): RealEstateCourtageInformation | undefined => undefined
